import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ChartDonutCardConfig, ChartDonutComponent} from "../../components/chart-donut/chart-donut.component";
import {TarjetaKpiComponent, TarjetaKpiData} from "../../components/tarjeta-kpi/tarjeta-kpi.component";
import {ChartBarCardConfig, ChartBarComponent} from "../../components/chart-bar/chart-bar.component";
import {
  ChartColumnCardConfig,
  ChartColumnComponent,
  ChartColumnConfig
} from "../../components/chart-column/chart-column.component";
import {
  TarjetaKpiComparisonComponent,
  TarjetaKpiComparisonData
} from "../../components/tarjeta-kpi-comparison/tarjeta-kpi-comparison.component";
import {PanelInsightsComponent, PanelInsightsConfig} from "../../components/panel-insights/panel-insights.component";
import {
  ChartLineCardConfig,
  ChartLineComponent,
  ChartLineConfig
} from "../../components/chart-line/chart-line.component";
import {ChartXYCardConfig, ChartXYComponent} from "../../components/chart-xy/chart-xy.component";
import {
  ListaMetricasCardConfig,
  ListaMetricasComponent
} from "../../components/lista-metricas/lista-metricas.component";
import {
  ChartTwoLinkedPieCardConfig,
  ChartTwoLinkedPieComponent
} from "../../components/chart-two-linked-pie/chart-two-linked-pie.component";
import {
  ChartRadialGaugeCardConfig,
  ChartRadialGaugeComponent
} from "../../components/chart-radial-gauge/chart-radial-gauge.component";

@Component({
  selector: 'app-dashboard-uikit',
  standalone: true,
  imports: [
    ChartDonutComponent,
    ChartBarComponent,
    ChartColumnComponent,
    TarjetaKpiComponent,
    TarjetaKpiComparisonComponent,
    PanelInsightsComponent,
    ChartLineComponent,
    ChartXYComponent,
    ListaMetricasComponent,
    ChartTwoLinkedPieComponent,
    ChartRadialGaugeComponent
  ],
  templateUrl: './dashboard-uikit.component.html',
  styleUrl: './dashboard-uikit.component.scss'
})
export class DashboardUikitComponent implements AfterViewInit {

  @ViewChild('donutChart') donutChart!: ChartDonutComponent;
  @ViewChild('barChart') barChart!: ChartBarComponent;
  @ViewChild('barColorChart') barColorChart!: ChartBarComponent;
  @ViewChild('barGroupedChart') barGroupedChart!: ChartBarComponent;
  @ViewChild('xyChart') xyChart!: ChartXYComponent;
  @ViewChild('xyRawChart') xyRawChart!: ChartXYComponent;
  @ViewChild('twoLinkedPieChart') twoLinkedPieChart!: ChartTwoLinkedPieComponent;
  @ViewChild('lineChart') lineChart!: ChartLineComponent;
  @ViewChild('linePerSeriesChart') linePerSeriesChart!: ChartLineComponent;
  @ViewChild('columnChart') columnChart!: ChartColumnComponent;
  @ViewChild('columnEfectividadChart') columnEfectividadChart!: ChartColumnComponent;
  @ViewChild('columnPerSeriesChart') columnPerSeriesChart!: ChartColumnComponent;
  @ViewChild('radialGaugeChart') radialGaugeChart!: ChartRadialGaugeComponent;
  @ViewChild('radialGaugeCustomChart') radialGaugeCustomChart!: ChartRadialGaugeComponent;

  constructor() {
    this.kpisInit();
    this.comparisonInit();
    this.panelInsightsGridInit();
    this.panelInsightsInit();
    this.donutInit();
    this.twoLinkedPieInit();
    this.lineInit();
    this.linePerSeriesInit();
    this.barColorInit();
    this.barGroupedInit();
    this.barInit();
    this.xyInit();
    this.xyRawInit();
    this.columnInit();
    this.columnEfectividadInit();
    this.columnPerSeriesInit();
    this.radialGaugeInit();
    this.listaInit();
  }

  ngAfterViewInit(): void {
    this.kpisLoad();
    this.comparisonLoad();
    this.panelInsightsLoad();
    this.panelInsightsGridLoad();
    this.donutLoad();
    this.twoLinkedPieLoad();
    this.lineLoad();
    this.linePerSeriesLoad();
    this.barGroupedLoad();
    this.barColorLoad();
    this.barLoad();
    this.xyLoad();
    this.xyRawLoad();
    this.columnLoad();
    this.columnEfectividadLoad();
    this.columnPerSeriesLoad();
    this.radialGaugeLoad();
    this.listaLoad();
  }

  //#region KPI Cards
  kpis: TarjetaKpiData[] = [];

  kpisInit(): void {
    this.kpis = [
      { label: 'Default', variant: '', value: '$0', iconSrc: 'assets/img/dashboard/kpi-analytics.svg' },
      { label: 'Green (g)', variant: 'g', value: '$0', iconSrc: 'assets/img/dashboard/kpi-document.svg' },
      { label: 'Amber (a)', variant: 'a', value: '$0', iconSrc: 'assets/img/dashboard/kpi-building.svg' },
      { label: 'Cyan (c)', variant: 'c', value: '$0', iconClass: 'pi-car' },
      { label: 'Purple (p)', variant: 'p', value: '0%', iconSrc: 'assets/img/dashboard/kpi-layers.svg' },
    ];
  }

  kpisLoad(): void {
    this.kpis = [
      {
        label: 'Default',
        variant: '',
        value: '$55.6M',
        sub: 'Sub text here',
        iconSrc: 'assets/img/dashboard/kpi-analytics.svg'
      },
      {
        label: 'Green (g)',
        variant: 'g',
        value: '$17.2M',
        sub: 'Green variant',
        iconSrc: 'assets/img/dashboard/kpi-document.svg'
      },
      {
        label: 'Amber (a)',
        variant: 'a',
        value: '$38.4M',
        sub: 'Amber / warning',
        iconSrc: 'assets/img/dashboard/kpi-building.svg',
        progressValue: 74,
        pill: '100 operaciones'
      },
      { label: 'Cyan (c)', variant: 'c', value: '$9.0M', sub: 'Cyan variant', iconClass: 'pi-car' },
      {
        label: 'Purple (p)',
        variant: 'p',
        value: '16.2%',
        sub: 'Purple variant',
        iconSrc: 'assets/img/dashboard/kpi-layers.svg'
      },
    ];
  }

  //#endregion KPI Cards

  //#region Tarjeta KPI Comparison
  comparisonData!: TarjetaKpiComparisonData;

  comparisonInit(): void {
    this.comparisonData = {
      title: 'Vehicular 80% / 20%',
      sub: 'Ene - May 2026',
      items: [
        { label: 'Gobernación', value: '$0', pct: 0, color: '#2d7dff' },
        { label: 'Municipios', value: '$0', pct: 0, color: '#00e5ff' },
      ],
    };
  }

  comparisonLoad(): void {
    this.comparisonData = {
      ...this.comparisonData,
      items: [
        { label: 'Gobernación', value: '$7.219M', pct: 80, color: '#2d7dff' },
        { label: 'Municipios', value: '$1.805M', pct: 20, color: '#00e5ff' },
      ],
    };
  }

  //#endregion Tarjeta KPI Comparison

  //#region panel insights
  panelInsights!: PanelInsightsConfig;

  panelInsightsInit(): void {
    this.panelInsights = {
      title: 'PanelInsights — list (default)',
      sub: "layout omitido o 'list' — lista vertical",
      pills: ['$9.024M', '3 ítems'],
      items: [],
    };
  }

  panelInsightsLoad(): void {
    this.panelInsights = {
      ...this.panelInsights,
      items: [
        { headline: '$9.024M recuperados', description: 'La gestión produjo recaudo sobre cartera coactiva.', cssClass: 'gio-green-color' },
        { headline: '+4.8% variación', description: 'El saldo crece por intereses; se debe acelerar la recuperación.', cssClass: 'gio-amber-color' },
        { headline: 'Embargos 27.1%', description: 'Mayor efectividad relativa; revisar capacidad para avanzar expedientes maduros.', cssClass: 'gio-cyan-color' },
      ],
    };
  }

  panelInsightsGrid!: PanelInsightsConfig;

  panelInsightsGridInit(): void {
    this.panelInsightsGrid = {
      title: 'PanelInsights — grid',
      sub: "layout: 'grid' — 2 columnas",
      layout: 'grid',
      pills: ['$18.32M'],
      items: [],
    };
  }

  panelInsightsGridLoad(): void {
    this.panelInsightsGrid = {
      ...this.panelInsightsGrid,
      items: [
        { headline: '$7.69M', description: 'Campaña persuasiva inmediata', cssClass: 'gio-green-color' },
        { headline: '$5.13M', description: 'Pre-liquidación y aviso', cssClass: 'gio-amber-color' },
        { headline: '$3.30M', description: 'Candidato a liquidación oficial', cssClass: 'gio-blue-color' },
        { headline: '$2.20M', description: 'Riesgo de pérdida de oportunidad', cssClass: 'gio-red-color' },
      ],
    };
  }
  //#endregion panel insights

  //#region  ChartDonut
  donutConfig!: ChartDonutCardConfig;

  donutInit(): void {
    this.donutConfig = {
      title: 'ChartDonut',
      sub: 'Donut / pie chart component',
      chart: {
        chartId: 'uikit-donut',
        centerLabel: '$0',
        centerSub: 'Total',
        slices: [],
      },
    };
  }

  donutLoad(): void {
    this.donutConfig.chart.centerLabel = '$46M';
    this.donutChart.load([
      { label: 'Liquidaciones', value: 28, color: '#2d7dff' },
      { label: 'Mandamientos', value: 18, color: '#a855f7' },
    ]);
  }
  //#endregion ChartDonut

  //#region ChartTwoLinkedPie
  twoLinkedPieConfig!: ChartTwoLinkedPieCardConfig;

  twoLinkedPieInit(): void {
    this.twoLinkedPieConfig = {
      title: 'ChartTwoLinkedPie',
      sub: 'Dos donuts vinculados — arrastra sectores entre ellos',
      chart: {
        chartId: 'uikit-two-linked-pie',
        data: [],
      },
    };
  }

  twoLinkedPieLoad(): void {
    this.twoLinkedPieChart.load([
      { category: 'Estampillas', value: 29798, side: 'right' },
      { category: 'Registro', value: 11560, side: 'right' },
      { category: 'Vehicular', value: 10513, side: 'right' },
      { category: 'Sobretasa', value: 5646, side: 'left' },
      { category: 'Adulto Mayor', value: 4802, side: 'left' },
      { category: 'Otros', value: 1911, side: 'left' },
    ]);
  }
  //#endregion ChartTwoLinkedPie

  //#region ChartLine
  lineConfig!: ChartLineCardConfig;

  lineInit(): void {
    this.lineConfig = {
      title: 'ChartLine — load()',
      sub: 'Dataset compartido — ambas series leen del mismo array',
      chart: {
        chartId: 'uikit-line',
        categoryField: 'mes',
        series: [
          { field: 'real', name: 'Real', color: '#00e676', dashed: false },
          { field: 'meta', name: 'Meta', color: '#ffb020', dashed: true },
        ],
        data: [],
      },
    };
  }

  lineLoad(): void {
    this.lineChart.load([
      { mes: 'Ene', real: 1.1, meta: 1.4 },
      { mes: 'Feb', real: 2.1, meta: 2.8 },
      { mes: 'Mar', real: 3.2, meta: 4.2 },
      { mes: 'Abr', real: 4.6, meta: 5.6 },
      { mes: 'May', real: null, meta: 7.0 },
      { mes: 'Jun', real: null, meta: 8.3 },
    ]);
  }

  linePerSeriesConfig!: { title: string; sub: string; chart: ChartLineConfig; seriesA: any[]; seriesB: any[]; };

  linePerSeriesInit(): void {
    this.linePerSeriesConfig = {
      title: 'ChartLine — load([ ])',
      sub: 'Datasets independientes por serie — sin merge en cliente',
      chart: {
        chartId: 'uikit-line-per-series',
        categoryField: 'mes',
        series: [
          { field: 'recaudo', name: 'Recaudo real', color: '#00e676' },
          { field: 'meta', name: 'Meta', color: '#ffb020', dashed: true },
        ],
        data: [],
      } as ChartLineConfig,
      seriesA: [],
      seriesB: [],
    };
  }

  linePerSeriesLoad(): void {
    this.linePerSeriesChart.load([
      [
        { mes: 'Ene', recaudo: 1.1 },
        { mes: 'Feb', recaudo: 2.1 },
        { mes: 'Mar', recaudo: 3.2 },
        { mes: 'Abr', recaudo: 4.6 },
      ],
      [
        { mes: 'Ene', meta: 1.4 },
        { mes: 'Feb', meta: 2.8 },
        { mes: 'Mar', meta: 4.2 },
        { mes: 'Abr', meta: 5.6 },
        { mes: 'May', meta: 7.0 },
        { mes: 'Jun', meta: 8.3 },
      ],
    ]);
  }
  //#endregion ChartLine

  //#region ChartBar — Color por barra
  barColorConfig!: ChartBarCardConfig;

  barColorInit(): void {
    this.barColorConfig = {
      title: 'ChartBar — Color por barra',
      sub: 'colorField + xLabelFormatter',
      chart: {
        chartId: 'uikit-bar-color',
        categoryField: 'label',
        xLabelFormatter: (v: number) => `$${v}M`,
        bars: [{ field: 'value', name: 'Valor', color: '#2d7dff', colorField: 'color', showValueLabel: true, valueLabelFormatter: (v: number) => `$${v}M` }],
        data: [],
      },
    };
  }

  barColorLoad(): void {
    this.barColorChart.load([
      { label: 'Cartera inicial', value: 28.4, color: '#2d7dff' },
      { label: 'Recuperado', value: 9.0, color: '#00e676' },
      { label: 'Saldo actual', value: 19.4, color: '#ffb020' },
    ]);
  }

  //#endregion ChartBar — Color por barra

  //#region ChartBar
  barConfig!: ChartBarCardConfig;

  barInit(): void {
    this.barConfig = {
      title: 'ChartBar',
      sub: 'Horizontal bar chart',
      chart: {
        chartId: 'uikit-bar',
        categoryField: 'vigencia',
        bars: [{ field: 'monto', name: 'Monto', color: '#2d7dff', showValueLabel: true }],
        data: [],
      },
    };
  }

  barLoad(): void {
    this.barChart.load([
      { vigencia: '2023', monto: 9.9 },
      { vigencia: '2022', monto: 8.9 },
      { vigencia: '2021', monto: 8.1 },
      { vigencia: 'Otros', monto: 16 },
    ]);
  }

  //#endregion ChartBar

  //#region ChartBar — Agrupado
  barGroupedConfig!: ChartBarCardConfig;

  barGroupedInit(): void {
    this.barGroupedConfig = {
      title: 'ChartBar — Agrupado',
      sub: 'bars[] — múltiples series por categoría',
      chart: {
        chartId: 'uikit-bar-grouped',
        categoryField: 'descripcion',
        xLabelFormatter: (v: number) => `$${v}M`,
        tooltipValueFormatter: (v: number) => `$${v}M`,
        bars: [
          { field: 'recaudo', name: 'Recaudo', color: '#a855f7', showValueLabel: true, valueLabelFormatter: (v: number) => `$${v}M` },
          { field: 'presupuesto', name: 'Presupuesto', color: '#ff4568', showValueLabel: true, valueLabelFormatter: (v: number) => `$${v}M` },
        ],
        data: [],
      },
    };
  }

  barGroupedLoad(): void {
    this.barGroupedChart.load([
      { descripcion: 'Vehicular', recaudo: 9.9, presupuesto: 12 },
      { descripcion: 'Registro', recaudo: 4.2, presupuesto: 5 },
      { descripcion: 'Sobretasa Gasolina', recaudo: 6.1, presupuesto: 6.5 },
      { descripcion: 'Estampilla Adulto Mayor', recaudo: 1.8, presupuesto: 2.2 },
    ]);
  }

  //#endregion ChartBar — Agrupado

  //#region ChartXY
  xyConfig!: ChartXYCardConfig;

  xyInit(): void {
    this.xyConfig = {
      title: 'ChartXY',
      sub: 'dataWide — datos ya pivotados, series definidas manualmente. Úsalo cuando controlas la estructura del dataset.',
      chart: {
        chartId: 'uikit-xy',
        categoryField: 'periodo',
        dataWide: {
          series: [
            { field: 'corriente', name: 'Corriente', color: '#00CFFF' },
            { field: 'vencido', name: 'Vencido', color: '#00B7F2' },
          ],
          data: [],
        },
      },
    };
  }

  xyLoad(): void {
    if (!this.xyConfig || !this.xyConfig.chart || !this.xyConfig.chart.dataWide) return;
    this.xyChart.load(this.xyConfig.chart.dataWide);
    this.xyConfig.chart.dataWide.data = [
      { periodo: 'ENE', corriente: 3.2, vencido: 1.8 },
      { periodo: 'FEB', corriente: 4.1, vencido: 2.2 },
      { periodo: 'MAR', corriente: 5.0, vencido: 2.9 },
      { periodo: 'ABR', corriente: 4.6, vencido: 2.5 },
      { periodo: 'MAY', corriente: 6.1, vencido: 3.1 },
      { periodo: 'JUN', corriente: 5.8, vencido: 2.8 },
    ];
    this.xyChart.load(this.xyConfig.chart.dataWide);
  }

  //#endregion ChartXY

  //#region ChartXYRaw
  xyRawConfig!: ChartXYCardConfig;

  xyRawInit(): void {
    this.xyRawConfig = {
      title: 'ChartXY — dataRaw',
      sub: 'dataRaw — filas en formato long (una por serie × período). El componente pivota y deriva las series automáticamente. Úsalo con datos de API.',
      chart: {
        chartId: 'uikit-xy-raw',
        categoryField: 'mes',
        dataRaw: {
          seriesField: 'impuesto',
          valueField: 'monto',
          seriesColors: {
            'ESTAMPILLAS': '#ffb020',
            'OTROS': '#a855f7',
            'REGISTRO Y ANOTACION': '#00e676',
            'VEHICULO AUTOMOTOR': '#00e5ff',
          },
          rows: [],
        },
      },
    };
  }

  xyRawLoad(): void {
    if (!this.xyRawConfig || !this.xyRawConfig.chart || !this.xyRawConfig.chart.dataRaw) return;
    this.xyRawConfig.chart.dataRaw.rows = [
      { impuesto: 'OTROS', mes: 'ENE', monto: 13092 },
      { impuesto: 'REGISTRO Y ANOTACION', mes: 'MAR', monto: 2668000 },
      { impuesto: 'REGISTRO Y ANOTACION', mes: 'ABR', monto: 607779 },
      { impuesto: 'ESTAMPILLAS', mes: 'ABR', monto: 73354000 },
      { impuesto: 'VEHICULO AUTOMOTOR', mes: 'ABR', monto: 22662558 },
      { impuesto: 'ESTAMPILLAS', mes: 'MAY', monto: 113324000 },
      { impuesto: 'OTROS', mes: 'JUN', monto: 1258293 },
      { impuesto: 'VEHICULO AUTOMOTOR', mes: 'JUN', monto: 3380000 },
    ];
    this.xyRawChart.load(this.xyRawConfig.chart.dataRaw);
  }
  //#endregion ChartXYRaw

  //#region ChartColumn
  columnConfig!: ChartColumnCardConfig;

  columnInit(): void {
    this.columnConfig = {
      title: 'ChartColumn — Barras + Línea',
      sub: 'Barras con serie de línea superpuesta y leyenda',
      chart: {
        chartId: 'uikit-column',
        categoryField: 'year',
        bars: [{ field: 'cartera', name: 'Cartera', color: '#2d7dff' }],
        lines: [{ field: 'recaudo', name: 'Recaudado', color: '#00e676' }],
        data: [],
      },
    };
  }

  columnLoad(): void {
    this.columnChart.load([
      { year: '2022', cartera: 7.8, recaudo: 1.2 },
      { year: '2023', cartera: 8.9, recaudo: 1.5 },
      { year: '2024', cartera: 8.6, recaudo: 1.4 },
      { year: '2025', cartera: 8.0, recaudo: 1.6 },
    ]);
  }
  //#endregion ChartColumn

  //#region ChartColumnEfectividad
  columnEfectividadConfig!: ChartColumnCardConfig;

  columnEfectividadInit(): void {
    this.columnEfectividadConfig = {
      title: 'ChartColumn — Color por barra + etiqueta',
      sub: 'colorField, showValueLabel, valueLabelSuffix, yMin/yMax, showLegend: false',
      chart: {
        chartId: 'uikit-column-efectividad',
        categoryField: 'etapa',
        showLegend: false,
        yMin: 0,
        yMax: 40,
        bars: [{
          field: 'pct',
          name: 'Efectividad',
          color: '#2d7dff',
          colorField: 'color',
          showValueLabel: true,
          valueLabelSuffix: '%',
        }],
        data: [],
      },
    };
  }

  columnEfectividadLoad(): void {
    this.columnEfectividadChart.load([
      { etapa: 'Etapa A', pct: 22.4, color: '#2d7dff' },
      { etapa: 'Etapa B', pct: 12.8, color: '#a855f7' },
      { etapa: 'Etapa C', pct: 27.1, color: '#ff4568' },
    ]);
  }

  //#endregion ChartColumnEfectividad

  //#region ChartColumnPerSeries
  columnPerSeriesConfig!: { title: string; sub: string; chart: ChartColumnConfig; };

  columnPerSeriesInit(): void {
    this.columnPerSeriesConfig = {
      title: 'ChartColumn — load([ ])',
      sub: 'Barras y línea desde datasets independientes, sin merge en cliente',
      chart: {
        chartId: 'uikit-column-per-series',
        categoryField: 'year',
        bars: [{ field: 'cartera', name: 'Cartera', color: '#2d7dff' }],
        lines: [{ field: 'recaudo', name: 'Recaudado', color: '#00e676' }],
        data: [],
      } as ChartColumnConfig,
    };
  }

  columnPerSeriesLoad(): void {
    this.columnPerSeriesChart.load([
      [
        { year: '2022', cartera: 7.8 },
        { year: '2023', cartera: 8.9 },
        { year: '2024', cartera: 8.6 },
        { year: '2025', cartera: 8.0 },
      ],
      [
        { year: '2022', recaudo: 1.2 },
        { year: '2023', recaudo: 1.5 },
        { year: '2024', recaudo: 1.4 },
      ],
    ]);
  }

  //#endregion ChartColumnPerSeries

  //#region chart radial gauge
  radialGaugeConfig!: ChartRadialGaugeCardConfig;
  radialGaugeCustomConfig!: ChartRadialGaugeCardConfig;

  radialGaugeInit(): void {
    this.radialGaugeConfig = {
      title: 'ChartRadialGauge',
      sub: 'RadarChart en semicírculo (0 - 100%)',
      chart: {
        chartId: 'uikit-radial-gauge',
        percentage: 0,
        centerSub: 'Efectividad',
      },
    };

    this.radialGaugeCustomConfig = {
      title: 'ChartRadialGauge — Personalizado',
      sub: 'Arco cian, pista personalizada y subtítulo a medida',
      chart: {
        chartId: 'uikit-radial-gauge-custom',
        percentage: 0,
        arcColor: '#00e5ff',
        trackColor: '#1e293b',
        centerSub: 'Meta Cumplida',
      },
    };
  }

  radialGaugeLoad(): void {
    this.radialGaugeChart.load(82);
    this.radialGaugeCustomChart.load(65);
  }
  //#endregion chart radial gauge

  //#region Lista Métricas
  listaConfig!: Required<ListaMetricasCardConfig>;

  listaInit(): void {
    this.listaConfig = {
      title: 'ListaMetricas',
      sub: 'Labeled metric rows with progress bars',
      chart: {
        items: [],
        total: { label: 'TOTAL', value: '$0', porcentajeLabel: '0%' },
      },
    };
  }

  listaLoad(): void {
    if (!this.listaConfig || !this.listaConfig.chart) return;
    this.listaConfig.chart.items = [
      { label: '0 - 6 meses', value: '$17M', porcentaje: 45, color: 'linear-gradient(90deg,#059669,#00e676)', labelColor: '#00e676' },
      { label: '6 - 12 meses', value: '$13M', porcentaje: 32, color: 'linear-gradient(90deg,#d97706,#ffb020)', labelColor: '#ffb020' },
      { label: '1 - 2 años', value: '$9M', porcentaje: 23, color: '#2d7dff' },
    ];
    this.listaConfig.chart.total = { label: 'TOTAL', value: '$39M', porcentajeLabel: '100%' };
  }

  //#endregion Lista Métricas
}
